<template>
  <svg
    v-if="value"
    xmlns="http://www.w3.org/2000/svg"
    class="h-6 w-6 m-auto"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
    color="#3498db"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    class="h-6 w-6 m-auto"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
    color="red"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
</template>

<script>
export default {
  name: 'Check',
  props: {
    value: {
      type: Boolean,
      require: true
    }
  }
};
</script>
